import React, { useState, useEffect, useMemo } from 'react';
import { buildApiClient } from '../../helpers/client'
import QuickSendModal from './components/QuickSendModal'
import QuickSendButton from './components/QuickSendButton'
import buildUrlMapper from './util/buildUrlMapper'

const customTemplateTypes = ["AutomatedEvent::EventManual", "AutomatedEvent::ProposalManual", "AutomatedEvent::LeadManual", "AutomatedEvent::AppointmentManual"]

const QuickSend = ({ apiKey, buttonProps, eventId, leadId, miniSessionId, appointmentId, bindTo }) => {
  const [ready, setReady] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [automatedEventTemplates, setAutomatedEventTemplates] = useState([])
  const [invitationTemplates, setInvitationTemplates] = useState({templates: [], users: []})
  const client = useMemo(() => buildApiClient(apiKey), [apiKey])
  const urlMapper = useMemo(() => buildUrlMapper({ eventId, leadId, miniSessionId, appointmentId }), [eventId, leadId, miniSessionId, appointmentId ])

  useEffect(() => {
    if(showModal && !ready) {
      loadData()
    }
  }, [showModal, ready])

  useEffect(() => {
    if(bindTo) {
      const element = document.querySelector(bindTo)
      element && element.addEventListener('click', handleOpenModal)
      return () => {
        element && element.removeEventListener('click', handleOpenModal)
      }
    }
  }, [bindTo])

  async function loadData() {
    await fetchAutomations()
    await fetchInvitations()
    setReady(true)
  }

  async function fetchAutomations() {
    const fetchAutomationsUrl = urlMapper.fetchAutomationsUrl()
    if(!fetchAutomationsUrl) return

    const response = await client.get(fetchAutomationsUrl)
    setAutomatedEventTemplates(response.data.data)
  }

  async function fetchInvitations() {
    const fetchInvitationsUrl = urlMapper.fetchInvitationsUrl()
    if(!fetchInvitationsUrl) return

    const response = await client.get(fetchInvitationsUrl)
    setInvitationTemplates({
      templates: response.data.automatedEvents.data,
      users: response.data.users.data
    })
  }

  const handleOpenModal = (e) => {
    if(e) e.preventDefault()

    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const customTemplates = automatedEventTemplates.filter(a => customTemplateTypes.includes(a.attributes.type))
  const automatedTemplates = automatedEventTemplates.filter(a => !customTemplateTypes.includes(a.attributes.type))

  return (
    <>
      { !bindTo && <QuickSendButton {...(buttonProps || {})} onClick={handleOpenModal} /> }
      <QuickSendModal
        show={showModal}
        onClose={handleCloseModal}
        customTemplates={customTemplates}
        automatedTemplates={automatedTemplates}
        invitationTemplates={invitationTemplates}
        urlMapper={urlMapper}
      />
    </>
  )
}

export default QuickSend;
